import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

const PrivateRoutes = () => {
  const { instance } = useMsal();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  // const isAuthenticated = () => {
  //   return localStorage.getItem("isLoggedIn") ? true : false;
  // };
  const userRoleLT = localStorage.getItem("LTRole");
  const userRoleCD = localStorage.getItem("CDRole");
  const cardTitle = localStorage.getItem("cardTitle");
  const CDPlantOptions = localStorage.getItem("CDPlantOptions");
  const LTPlantOptions = localStorage.getItem("LTPlantOptions");

  if (LTPlantOptions && JSON.parse(LTPlantOptions)?.length > 0 && !userRoleLT) {
    window.location.href = '/landing-page'
    return null;
  }
  if (CDPlantOptions && JSON.parse(CDPlantOptions)?.length > 0 && !userRoleCD) {
    window.location.href = '/landing-page'
    return null;
  }
  if (!cardTitle) {
    window.location.href = '/landing-page'
    return null;
  }

  const roleBasedRoutesLT = {
    Planner: ["/landing-page", "/lt-dashboard", "/analytics-results", "/material_details", "/s4datasyncstatus-planner", "/reports", "/ct-dashboard", "/kpi-tracking", "/inventory-impact-simulation", "/lt-ticketsummary","/ar-dashboard"],
    Admin: ["/landing-page", "/run-analytics-scheduler", "/admin-analytics-results", "/admin-analytics-results-details", "/parameter-configuration", "/planner-material-mapping", "/s4datasyncstatus", "/reports", "/ct-dashboard", "/kpi-tracking", "/inventory-impact-simulation", "/lt-ticketsummary","/ar-dashboard"],
    Approver: ["/landing-page", "/approval-management", "/detailed-results-approval", "/reports", "/ct-dashboard", "/kpi-tracking", "/inventory-impact-simulation", "/lt-ticketsummary","/ar-dashboard"],
    Viewer: ["/landing-page", "/viewer-analytics-results", "/viewer-analytics-results-details", "/run-analytics-scheduler", "/parameter-configuration", "/s4datasyncstatus", "/planner-material-mapping", "/reports", "/ct-dashboard", "/kpi-tracking", "/inventory-impact-simulation", "/lt-ticketsummary","/ar-dashboard"],
    GMP: ["/landing-page", "/gmp-dashboard", "/gmp-analytics-results", "/gmp-analytics-results-details", "/gmp-s4datasyncstatus", "/reports", "/ct-dashboard", "/kpi-tracking", "/inventory-impact-simulation", "/lt-ticketsummary","/ar-dashboard"],
  };
  const roleBasedRoutesMDM = {
    Viewer: ["/landing-page", "/cd-dashboard", "/price-memo", "/price-memo/data-errors", "/contracts", "/reportings", "/contract-maintenance", "/contract-maintenance/new-contract", "/contract-maintenance/update-contract", "/contract-maintenance/review-auto-target-value", "/cm-reports", "/cd-dashboard","/quota-maintenance","/quota-maintenance/results","/ticket-summary"],
    Analyst: ["/landing-page", "/price-memo", "/price-memo/data-errors", "/contracts", "/reportings", "/contract-maintenance", "/contract-maintenance/new-contract", "/contract-maintenance/update-contract", "/contract-maintenance/review-auto-target-value", "/cm-reports", "/quota-maintenance", "/quota-maintenance/results", "/ticket-summary", "/pricememo-maintenance", "/cd-dashboard"],
    MOP: ["/landing-page", "/price-memo", "/price-memo/data-errors", "/contracts", "/reportings", "/contract-maintenance", "/contract-maintenance/new-contract", "/contract-maintenance/update-contract", "/contract-maintenance/review-auto-target-value", "/cm-reports", "/quota-maintenance","/quota-maintenance/results", "/ticket-summary","/pricememo-maintenance", "/cd-dashboard"],
    "Price Memo Owner (Packaging)": ["/landing-page", "/pricememo-management", "/audit-logs","/quota-maintenance","/quota-maintenance/results","/ticket-summary"],
    "Price Memo Viewer (Packaging)": ["/landing-page", "/packaging-viewer-pricememo", "/audit-logs","/quota-maintenance","/quota-maintenance/results","/ticket-summary"],
    "Price Memo Owner (CEPG)": ["/landing-page", "/pricememo-management", "/audit-logs","/quota-maintenance","/quota-maintenance/results","/ticket-summary"],
    "Price Memo Viewer (CEPG)": ["/landing-page", "/packaging-viewer-pricememo", "/audit-logs","/quota-maintenance","/quota-maintenance/results","/ticket-summary"],
  };

  const isRouteAllowedLT = roleBasedRoutesLT[userRoleLT]?.includes(location?.pathname);
  const isRouteAllowedMDM = roleBasedRoutesMDM[userRoleCD]?.includes(location?.pathname);

  if (isAuthenticated) {
    if ((isRouteAllowedLT && cardTitle === "Lead Time Analytics") || (isRouteAllowedMDM && cardTitle === "Contract Data Update") || (isRouteAllowedMDM && cardTitle === "Control Tower")) {
      return <Outlet />
    } else {
      return <Navigate to="/unauthorized" replace />;
    }
  } else {
    const loginRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    instance.loginRedirect(loginRequest)
      .catch(e => {
        console.error(e);
      });
  }
};

export default PrivateRoutes;